import { Modifier } from "@/dto/modifier";
import { ItemNameWithQuantity } from "./itemNameWithQuantity";
import { AgeRestricted } from "@/components/ageRestricted/ageRestricted";
import { CartItemModifierList } from "./cartItemModifierList";
import React from "react";

export interface ScanToOrderCartItemLeftProps {
  name: string;
  quantity: number;
  isAgeRestricted?: boolean;
  modifiers: Modifier[];
  specialInstructions?: string;
  onTileClick?: () => void;
  isAlreadySentToKitchen?: boolean;
}

export const ScanToOrderCartItemLeft = ({
  name,
  quantity,
  isAgeRestricted,
  modifiers,
  specialInstructions,
  onTileClick,
  isAlreadySentToKitchen,
}: ScanToOrderCartItemLeftProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onTileClick?.();
    }
  };

  return (
    <button
      disabled={isAlreadySentToKitchen}
      aria-disabled={isAlreadySentToKitchen}
      onClick={onTileClick}
      onKeyDown={handleKeyDown}
      className={`w-full flex flex-col items-start ${
        !isAlreadySentToKitchen ? "cursor-pointer" : "cursor-not-allowed"
      }`}
    >
      <ItemNameWithQuantity name={name} quantity={quantity} />
      {isAgeRestricted && <AgeRestricted />}
      <CartItemModifierList
        modifiers={modifiers}
        specialInstructions={specialInstructions}
      />
    </button>
  );
};
